import { Row, Col } from 'react-bootstrap';

const StockItem = ({ id, name, quantity, maxQuantity, barColor }) => {
    const percentage = maxQuantity > 0 ? (quantity / maxQuantity) * 100 : 0;

    const rankCircleStyle = {
    backgroundColor: '#E8F5E9',
    color: barColor,
    borderRadius: '50px',
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '0.8rem',
    flexShrink: 0, 
};

    return (
        <div className="mb-3">
            <Row className="align-items-center g-4">
                <Col xs={7} className="d-flex align-items-center">
                    <span className="fw-medium text-truncate" title={name}>{name}</span>
                </Col>
                <Col xs={1} className="text-end">
                    <div className='d-flex gap-2'>
                        <div style={rankCircleStyle}>{quantity}</div>
                        <span>Purchased</span>
                    </div>

                </Col>
            </Row>

            <Row className="g-0 mt-1">
                <Col xs={11}>
                    <div style={{ height: '6px', backgroundColor: '#f0f0f0', borderRadius: '4px' }}>
                        <div
                            style={{
                                width: `${percentage}%`,
                                height: '100%',
                                backgroundColor: barColor,
                                borderRadius: '4px'
                            }}
                        />
                    </div>
                </Col>
                <Col xs={1} />
            </Row>
        </div>
    );
};

const MostPurchaseStock = ({ purchasedStocks = [] }) => {
    const colorPalette = ['#342D56', '#CBA370', '#4CAF50', '#2196F3', '#FF9800'];

    const maxQuantity = purchasedStocks.length > 0 ?
        Math.max(...purchasedStocks.map(stock => parseInt(stock.TotalQuantitePurchased) || 0)) : 0;

    return (
        <div className="col-xxl-6 col-xl-12">
            <div className="card h-100">
                <div className="card-body">
                    <h6 className="text-lg mb-20" style={{ color: '#1B5E20', fontWeight: 'bold' }}>
                        Most Purchased Stocks
                    </h6>

                    <div className="d-flex flex-column gap-10">
                        {purchasedStocks.length > 0 ? (
                            purchasedStocks.map((stock, index) => (
                                <StockItem
                                    key={index}
                                    id={index + 1}
                                    name={stock.StockName}
                                    quantity={parseInt(stock.TotalQuantitePurchased) || 0}
                                    maxQuantity={maxQuantity}
                                    barColor={colorPalette[index % colorPalette.length]}
                                />
                            ))
                        ) : (
                            <div className="text-center text-muted py-3">
                                No stock purchase data available
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MostPurchaseStock;